import { useContext } from 'react';
import {
  DREAM_COMPONENTS_CONTEXT_DEFAULT_VALUES,
  DreamComponentsContext,
  type DreamComponentsContextType,
} from './context';

export const useDreamComponentsContext = (): DreamComponentsContextType => {
  const context = useContext(DreamComponentsContext) ?? DREAM_COMPONENTS_CONTEXT_DEFAULT_VALUES;
  return context;
};
